import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 添加token
    const token = store.getters.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码不是成功状态
    if (!res.success) {
      ElMessage({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    }
    
    return res
  },
  error => {
    console.error('响应错误:', error)
    
    let message = '网络异常'
    let showMessage = true
    
    if (error.response) {
      const { status, data } = error.response
      
      switch (status) {
        case 400:
          // 对于400错误（通常是验证错误），不在拦截器中显示消息
          // 让组件自己处理详细的验证错误
          showMessage = false
          break
        case 401:
          message = '登录已过期，请重新登录'
          store.dispatch('user/logout')
          router.push('/login')
          break
        case 403:
          message = '没有访问权限'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = data?.message || `请求失败 (${status})`
      }
    } else if (error.code === 'ECONNABORTED') {
      message = '请求超时'
    }
    
    if (showMessage) {
      ElMessage({
        message,
        type: 'error',
        duration: 3000
      })
    }
    
    return Promise.reject(error)
  }
)

export default request
